'use client';

import { useApi } from '@prismo-io/core';
import type { SWRArgs } from '@prismo-io/schemas';
import useSWRMutation from 'swr/mutation';
import {
  type PrivacyParamsSchemaT,
  updateUserPrivacy,
} from '../utils/update-user';

export const useUpdateUserPrivacy = () => {
  const { client } = useApi();

  return useSWRMutation(
    'users',
    (key, { arg }: SWRArgs<PrivacyParamsSchemaT>) => {
      return updateUserPrivacy(client, arg);
    }
  );
};
